/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { BATTLESHIP, OLAF, GREAT_WHITE, CALYPSO, OZ } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { crmSuiteProductLevelSelector } from '../../selectors/ProductsSelectors';
import { commonAvailableTermsSelector } from '../../selectors/OfferSelectors';
const StyledTermOption = styled.div.withConfig({
  displayName: "DetailedTermSelector__StyledTermOption",
  componentId: "sc-1dfz4vq-0"
})(["width:calc(50% - 10px);display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:initial;z-index:2;text-align:center;"]);
const StyledPaymentLabel = styled.div.withConfig({
  displayName: "DetailedTermSelector__StyledPaymentLabel",
  componentId: "sc-1dfz4vq-1"
})(["font-size:11px;font-weight:600;"]);
const StyledCommitmentLabel = styled.div.withConfig({
  displayName: "DetailedTermSelector__StyledCommitmentLabel",
  componentId: "sc-1dfz4vq-2"
})(["font-size:11px;"]);

const getDiscountPercentageToShow = (discount1, discount2) => {
  const relativeDiscount = Math.abs(100 - discount1 - (100 - discount2)) / (100 - Math.min(discount1, discount2)) * 100; // We're slowly moving away from showing annual discounts to avoid displaying
  // arbitrary numbers in cases like this, where we're doing the calculation ourselves, such as for
  // regional promotions. Currently, we only show it when the relative discount is 10%.

  if (relativeDiscount !== 10) return null;
  return relativeDiscount;
};

const DetailedTermSelector = ({
  className,
  skuIds,
  onChange,
  trackingSource,
  activeTerm
}) => {
  const suiteProductLevel = useSelector(state => crmSuiteProductLevelSelector(state, {
    skuIds
  }));
  const availableTerms = useSelector(state => commonAvailableTermsSelector(state, {
    skuIds
  })); // More context on why we're not showing the annual discount percent for CRM suite
  // https://hubspot.slack.com/archives/C824F0ZB5/p1618237316080300

  const annualDiscountPercent = suiteProductLevel ? null : availableTerms[0].discount === 0 ? availableTerms[1].discount : // For retail, both monthly and annual terms have a non-zero discount, so we can't show the
  // absolute value of the discount directly. The last part of the ternary calculates the relative
  // discount percentage for annual terms on the terms selector when both monthly and annual
  // discounts are non-zero.
  getDiscountPercentageToShow(availableTerms[0].discount, availableTerms[1].discount);
  const discountMessage = `${Math.round(annualDiscountPercent)}PercentDiscount`;
  useEffect(() => {
    getUsageTracker().track('termSelectorInteraction', {
      action: 'view',
      discountShown: discountMessage,
      term: activeTerm,
      trackingSource
    });
  }, []);

  const onToggleChange = () => {
    const newQueryParamTerm = activeTerm === MONTHLY ? ANNUAL : MONTHLY;
    onChange(newQueryParamTerm);
    getUsageTracker().track('termSelectorInteraction', {
      action: 'click',
      discountShown: discountMessage,
      term: newQueryParamTerm,
      trackingSource
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    style: {
      backgroundColor: GREAT_WHITE,
      border: `1px solid ${BATTLESHIP}`,
      width: '100%',
      borderRadius: 30000,
      padding: '6px 10px',
      display: 'flex',
      position: 'relative',
      cursor: 'pointer'
    },
    className: className,
    onClick: onToggleChange,
    "data-selenium-id": `term-selector-${trackingSource}`,
    children: [/*#__PURE__*/_jsxs(StyledTermOption, {
      children: [/*#__PURE__*/_jsx(StyledPaymentLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailedTermSelector.payMonthly"
        })
      }), /*#__PURE__*/_jsx(StyledCommitmentLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: availableTerms[0].commitment === ANNUAL ? 'detailedTermSelector.commitAnnually' : 'detailedTermSelector.commitMonthly'
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        width: 20
      }
    }), /*#__PURE__*/_jsxs(StyledTermOption, {
      children: [/*#__PURE__*/_jsxs(StyledPaymentLabel, {
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            display: 'inline-block'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: availableTerms[1].payment === ANNUAL ? 'detailedTermSelector.payUpfront' : 'detailedTermSelector.payMonthly'
          })
        }), Boolean(annualDiscountPercent) && /*#__PURE__*/_jsx("span", {
          className: "m-left-1",
          style: {
            textTransform: 'uppercase',
            color: OZ,
            whiteSpace: 'nowrap'
          },
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "detailedTermSelector.saveDiscount",
            options: {
              discount: /*#__PURE__*/_jsx(FormattedPercentage, {
                value: Math.round(annualDiscountPercent)
              })
            }
          })
        })]
      }), /*#__PURE__*/_jsx(StyledCommitmentLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailedTermSelector.commitAnnually"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        left: activeTerm === MONTHLY ? -3 : 'calc(50% - 3px)',
        height: 'calc(100% + 6px)',
        width: 'calc(50% + 6px)',
        background: OLAF,
        borderRadius: 3000,
        top: -3,
        border: `1px solid ${CALYPSO}`,
        transition: 'all 0.2s ease-in-out'
      }
    })]
  });
};

export default DetailedTermSelector;